import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  trasporti: [],
  singleTrasport: {},
  isLoading: false,
  error: null,
  viaggio: [],
  mezzoViaggo: [],
  trattori: [],
  enumLoading: {
    viaggio: false,
    mezzoViaggo: false,
    trattori: false
  },
  enumError: {
    viaggio: null,
    mezzoViaggo: null,
    trattori: null
  }
}

const trasportoSlice = createSlice({
  name: 'trasportoData',
  initialState,
  reducers: {
    setTrasporti: (state, action) => {
      state.trasporti = action.payload
    },
    addTrasporti: (state, action) => {
      state.trasporti.push(action.payload)
    },
    addTrasportiId: (state, action) => {
      state.singleTrasport = action.payload
    },
    updateTrasporti: (state, action) => {
      const index = state.trasporti.findIndex(t => t.id === action.payload.id)
      if (index >= -1) {
        state.trasporti[index] = action.payload
      }
    },
    deleteTrasporti: (state, action) => {
      state.trasporti = state.trasporti.filter(
        (item) => item.id !== action.payload
      );
    },
    apiRequestStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    apiRequestSuccess: (state) => {
      state.isLoading = false;
    },
    apiRequestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setViaggio: (state, action) => {
      state.viaggio = action.payload;
    },
    setTrattori: (state, action) => {
      state.trattori = action.payload;
    },
    setMezzoViaggo: (state, action) => {
      state.mezzoViaggo = action.payload;
    },
    enumRequestStart: (state, action) => {
      state.enumLoading[action.payload] = true;
      state.enumError[action.payload] = null;
    },
    enumRequestSuccess: (state, action) => {
      state.enumLoading[action.payload] = false;
    },
    enumRequestFailure: (state, action) => {
      const { enumType, error } = action.payload;
      state.enumLoading[enumType] = false;
      state.enumError[enumType] = error;
    }
  }
})
export const {
  setTrasporti,
  addTrasporti,
  addTrasportiId,
  updateTrasporti,
  deleteTrasporti,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
  setViaggio,
  setTrattori,
  setMezzoViaggo,
  enumRequestStart,
  enumRequestSuccess,
  enumRequestFailure
} = trasportoSlice.actions;

export const selectTrasporti = (state) => state.trasporto.trasporti;
export const selectSingleTrasporti = (state) => state.trasporto.singleTrasporti;
export const selectIsLoading = (state) => state.trasporto?.isLoading;
export const selectError = (state) => state.trasporto?.error;
export const selectViaggio = (state) => state.trasporto?.viaggio;
export const selectTrattori = (state) => state.trasporto?.trattori;
export const selectMezzaViaggo = (state) => state.trasporto?.mezzoViaggo;

export default trasportoSlice.reducer;
